import { connect } from 'react-redux';
import {
  getConferencesList,
  setConferencesFilter,
  setConferencesOrder,
  regeneratePinFromDashboard,
  cancelConferenceCall,
} from '@actions/conferences';
import { requestHumanTranscript, resetConference } from '@actions/conference';
import {
  selectList,
  fromConferences as from,
  selectIsFetching,
  selectPagination,
  selectFilters,
} from '@selectors/dashboard';
import DashboardPage from './DashboardPage';

const mapStateToProps = (state) => ({
  list: selectList(from(state)),
  isFetching: selectIsFetching(from(state)),
  ...selectPagination(from(state)),
  ...selectFilters(from(state)),
  countries: state.countries,
  isRegenerating: state.conferences.isRegenerating,
});

const mapDispatchToProps = {
  getDashboardList: getConferencesList,
  setFilterField: setConferencesFilter,
  setOrder: setConferencesOrder,
  regeneratePinFromDashboard,
  cancelConferenceCall,
  requestHumanTranscript,
  resetConference,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardPage);



// WEBPACK FOOTER //
// ./components/pages/DashboardPage/Conferences.js